// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { CustomerCostCodeDto } from "@insite/client-framework/Types/ApiModels";

import { Draft } from "immer";

export interface ShipTosDataStateModel {
    costCodeCollection: CustomerCostCodeDto[] | null;
}

const initialState: ShipTosDataStateModel = {
    costCodeCollection: null,
};
const reducer = {
    "xShipTosData/LoadShipTosCostCodeCollection": (
        draft: Draft<ShipTosDataStateModel>,
        action: { costCodeCollection: CustomerCostCodeDto[] },
    ) => {
        draft.costCodeCollection = action.costCodeCollection;
    },
};

const xShipTosData = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xShipTosData = xShipTosData;

export type xShipTosData = {
    xShipTosData: ShipTosDataStateModel;
} & ApplicationState;

type ShipTosDataReducer = {
    shipTosData: typeof xShipTosData;
};

export type ShipTosDataActions = Parameters<ShipTosDataReducer[keyof ShipTosDataReducer]>[1] | AnyAction;
